import { BooleanInput } from '@angular/cdk/coercion';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'app/app.service';
import { SecurityContextSupplier } from 'app/core/authorization';
import { BackendVersionInfo, BackendVersionService } from 'app/core/services/backend-version.service';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { catchError, Observable, of, Subject, takeUntil } from 'rxjs';
import packageInfo from '../../../../../package.json';

@Component({
	selector: 'user',
	templateUrl: './user.component.html',
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	exportAs: 'user',
})
export class UserComponent implements OnInit, OnDestroy {
	/* eslint-disable @typescript-eslint/naming-convention */
	static ngAcceptInputType_showAvatar: BooleanInput;
	/* eslint-enable @typescript-eslint/naming-convention */

	@Input() showAvatar: boolean = true;
	user: User;
	version = packageInfo.version;
	backendVersion$: Observable<BackendVersionInfo>;

	private _unsubscribeAll: Subject<any> = new Subject<any>();

	/**
	 * Constructor
	 */
	constructor(
		private _changeDetectorRef: ChangeDetectorRef,
		private _router: Router,
		private _userService: UserService,
		// private _keycloakService: KeycloakService
		private _securityContextSupplier: SecurityContextSupplier,
		public readonly appService: AppService,
		private _backendVersionService: BackendVersionService
	) {
		// Observable será inicializado no ngOnInit
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		console.log('UserComponent inicializado, criando Observable do backend...');

		// Initialize backend version observable
		this.backendVersion$ = this._backendVersionService.getVersion().pipe(
			catchError(error => {
				console.warn('Erro ao buscar versão do backend:', error);
				return of({ version: 'N/A', name: 'backend-offline' });
			})
		);

		// Subscribe to user changes
		this._userService.user$
		     .pipe(takeUntil(this._unsubscribeAll))
		     .subscribe((user: User) => {
		         this.user = user;

		         // Mark for check
		         this._changeDetectorRef.markForCheck();
		     });
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Update the user status
	 *
	 * @param status
	 */
	updateUserStatus(status: string): void {
		// Return if user is not available
		if (!this.user) {
			return;
		}

		// Update the user
		this._userService
			.update({
				...this.user,
				status,
			})
			.subscribe();
	}

	/**
	 * Sign out
	 */
	async signOut(): Promise<void> {
		// this._router.navigate(['/sign-out']);
		// this._keycloakService.logout(environment.auth.logoutUri);
		this._securityContextSupplier.logout();
	}

	/**
	 * Sign out
	 */
	changelog(): void {
		this._router.navigate(['/docs/changelog']);
	}
}
